import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useDocumentState } from '../../../../../contexts/DocumentContext';
import { DocumentStatusEnum } from '../../../../../shared/constants/document';
import { DropdownToggleBlue, DropdownBody } from '../../../../dropdown';
import CancelExternalSigningModal from '../headerActions/cancelExternalSigning/cancelExternalSigningModal';
import SendSigningReminderModal from '../headerActions/sendSigningReminder/sendSigningReminderModal';
import { UpdateSignersModal } from '../../../../modals/UpdateSignersModal';
import styles from './ExecutePageActions.module.scss';

interface ExecutePageActionsProps {
  documentId: string;
  dealId: string;
  teamId: string;
  documentTitle?: string;
  hasEditPermission: boolean;
}

export const ExecutePageActions: React.FC<ExecutePageActionsProps> = ({
  documentId,
  dealId,
  teamId,
  documentTitle,
  hasEditPermission,
}) => {
  const [showCancelSigningModal, setShowCancelSigningModal] = useState(false);
  const [showSendReminderModal, setShowSendReminderModal] = useState(false);
  const [showUpdateSignersModal, setShowUpdateSignersModal] = useState(false);
  const [isDropdownToggled, setIsDropdownToggled] = useState(false);

  const { state } = useDocumentState();
  const documentStatus = state.status;
  const isSigning = documentStatus === DocumentStatusEnum.SIGNING;
  const isExecuted = documentStatus === DocumentStatusEnum.EXECUTED;

  // Only show actions dropdown if document is in signing status
  if (!isSigning) {
    return null;
  }

  const handleCancelSigning = () => {
    setShowCancelSigningModal(true);
    setIsDropdownToggled(false);
  };

  const handleSendReminder = () => {
    setShowSendReminderModal(true);
    setIsDropdownToggled(false);
  };

  const handleUpdateSigners = () => {
    setShowUpdateSignersModal(true);
    setIsDropdownToggled(false);
  };

  return (
    <>
      <div className={styles.actionsContainer}>
        <Dropdown show={isDropdownToggled} onToggle={() => setIsDropdownToggled(!isDropdownToggled)}>
          <Dropdown.Toggle id="dropdown-execute-actions" as={DropdownToggleBlue} disabled={isExecuted}>
            <span className={styles.dropdownTitle}>Actions</span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <div className={styles.dropdownBodyWrapper}>
              <DropdownBody>
                {isSigning && hasEditPermission && (
                  <Dropdown.Item onClick={handleUpdateSigners} className={styles.dropdownItem}>
                    Update Signers
                  </Dropdown.Item>
                )}
                {isSigning && (
                  <Dropdown.Item onClick={handleSendReminder} className={styles.dropdownItem}>
                    Send Reminder
                  </Dropdown.Item>
                )}
                {isSigning && (
                  <Dropdown.Item onClick={handleCancelSigning} className={styles.dropdownItem}>
                    Cancel Signing
                  </Dropdown.Item>
                )}
              </DropdownBody>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Modals */}
      <CancelExternalSigningModal
        show={showCancelSigningModal}
        onHide={() => setShowCancelSigningModal(false)}
        documentId={documentId}
        dealId={dealId}
        teamId={teamId}
      />

      <SendSigningReminderModal
        show={showSendReminderModal}
        onHide={() => setShowSendReminderModal(false)}
        documentId={documentId}
        dealId={dealId}
        teamId={teamId}
      />

      <UpdateSignersModal
        show={showUpdateSignersModal}
        onHide={() => setShowUpdateSignersModal(false)}
        documentId={documentId}
      />
    </>
  );
};
